import { monitorDropsStreamsEndpoint } from 'root/src/server/modules/streams/endpoints/monitorDropsStreams.endpoint';
export const streamsEndpoints = Object.assign({}, monitorDropsStreamsEndpoint);
